import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { Container } from '../../layout/Container'
import { Card } from '../../ui/Card'
import { cn } from '../../../lib/utils'
import { Brain, Wrench, ShieldCheck, ArrowRight } from 'lucide-react'

const modules = [
  { key: 'brain', label: 'header.brain', href: '/plataforma/brain', icon: Brain },
  { key: 'build', label: 'header.build', href: '/plataforma/build', icon: Wrench },
  { key: 'govern', label: 'header.govern', href: '/plataforma/govern', icon: ShieldCheck },
]

export function ModuleNav() {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <section className="border-t border-border bg-surface py-16">
      <Container size="wide">
        <p className="text-center text-sm font-medium uppercase tracking-wider text-text-muted">
          {t('platformPages.common.exploreModules')}
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-3">
          {modules.map((module, index) => {
            const isActive = location.pathname === module.href
            const Icon = module.icon
            return (
              <motion.div
                key={module.key}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <Link to={module.href} aria-current={isActive ? 'page' : undefined}>
                  <Card
                    variant={isActive ? 'gradient' : 'elevated'}
                    hover={!isActive}
                    className={cn(
                      'group flex h-full items-center justify-between',
                      isActive && 'pointer-events-none border-accent/30',
                    )}
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className={cn(
                          'flex h-10 w-10 items-center justify-center rounded-xl transition-colors',
                          isActive
                            ? 'bg-accent text-white'
                            : 'bg-surface text-text-secondary group-hover:bg-accent/10 group-hover:text-accent-light',
                        )}
                      >
                        <Icon className="h-5 w-5" />
                      </div>
                      <div>
                        <p className="font-medium text-text-primary">{t(module.label)}</p>
                        <p className="text-sm text-text-secondary">
                          {t(`platformPages.${module.key}.shortDescription`)}
                        </p>
                      </div>
                    </div>
                    <ArrowRight
                      className={cn(
                        'h-5 w-5 flex-shrink-0 transition-transform',
                        isActive
                          ? 'text-text-muted'
                          : 'text-text-secondary group-hover:translate-x-1 group-hover:text-accent-light',
                      )}
                    />
                  </Card>
                </Link>
              </motion.div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
